import { render, staticRenderFns } from "./GroupDetailsStaticIcon.vue?vue&type=template&id=43cd1b23&scoped=true"
import script from "./GroupDetailsStaticIcon.vue?vue&type=script&lang=js"
export * from "./GroupDetailsStaticIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd1b23",
  null
  
)

export default component.exports